import OrderFinancialActions from "../pageInside/payments/OrderFinancialActions";
import OrderPaymentMethod from "../pageInside/payments/OrderPaymentMethod";
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Link } from "react-router-dom";
import { elakayFromNow } from "../../utils/elakayDate";
import {

    isAuthenticated,
    OrdersBViewById,
    updateOrder,
    getGraphicOrder,
} from "../auth";
import { retrievePayment, getPaymentIntentView } from "../auth/stripe";
import {getLakayUser } from "../auth/apiProduct";
import { orderLineTaxCents, orderLineTaxText } from "../pageInside/checkoutTaxDisplay";
import SwiperPubCategoryProdMatrix from "../slider/swiperUserProd/swiperPubCategoryProdMatrix.jsx";
import Filters from '../pageInside/FilterProduct';
import ShowimagesLoading from "../pageInside/showImagesLoading";
import GraffitiOrderClient from "../pageInside/Graffiticonfiguratorartifact/GraffitiOrderClient.jsx";
import './OrdersView.css';
import { elakayAutoText, elakayPluralRule, getElakayLanguageContext } from "../pageInside/dataElakay";
import { useDropshippingText } from "../dropshippingInterne/i18n";
import { safeTrackingUrl, statusLabel } from "../dropshippingInterne/ui/orderFulfillment";
import { orderStatusLabel } from "./purchased/OrderStatusBadge";
import { childrenOf, reasonGroupForStatus, reasonsForStatus, ticketGroup } from "../pageInside/orderTicketReasons";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
// Current language source: the app-wide one (always up to date after a language switch), else
// the infoSource this module last rendered with.
const __elakayLanguageSource = () => getElakayLanguageContext?.() || __elakayInfoSource;
const __elakayText = (key, fallback) =>
  __elakayLanguageSource()?.laguangeElakay?.("frontElakayHardcodedText", __elakayLanguageSource().languageAPI)?.["ordersView"]?.[key] || fallback;

// ═══════════════════════════════════════════════════════════════════════════
// HELPERS
// ═══════════════════════════════════════════════════════════════════════════


const filterProductSel = (fil) => {
    if (fil?.products?.filter)            return fil.products.filter;
    if (fil?.prod_filterProduct?.filter)  return fil.prod_filterProduct.filter;
    return { type: "none", size: "none", color: "none" };
};

const objNotEmpty = (obj) => {
    if (!obj || typeof obj !== 'object') return false;
    return Object.keys(obj).length > 0;
};

const formatCurrency = (value) =>
    Number(value || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' });

// ═══════════════════════════════════════════════════════════════════════════
// ReadMoreLess — composant unique pour "see more / see less"
// ═══════════════════════════════════════════════════════════════════════════

const ReadMoreLess = ({ infoSource, text, textLess = 'futur.', showNB = true }) => {
  __setElakayInfoSource(infoSource);
    const [isExpanded, setIsExpanded] = useState(false);

    if (!text) return null;

    const previewLength  = text.indexOf(textLess) + (textLess?.length || 0);
    const previewText    = previewLength > 0 ? text.slice(0, previewLength) : text;
    const remainingText  = previewLength > 0 ? text.slice(previewLength) : '';

    const seeMore = infoSource?.language?.(infoSource, "Link", "seeMore") || 'See more';
    const seeLess = infoSource?.language?.(infoSource, "Link", "seeLess") || 'See less';

    return (
        <div className="ov-read-more">
            <p>
                {showNB && <strong>{__elakayText("t001", "NB:")}</strong>}
                {previewText}
                {!isExpanded && remainingText && '...'}
                {isExpanded && remainingText}
                {remainingText && (
                    <span
                        className="ov-read-more-link"
                        onClick={() => setIsExpanded(!isExpanded)}
                        role="button"
                        tabIndex={0}
                    >
                        {isExpanded ? seeLess : seeMore}
                    </span>
                )}
            </p>
        </div>
    );
};

// ═══════════════════════════════════════════════════════════════════════════
// HOOK — responsive nbrArr
// ═══════════════════════════════════════════════════════════════════════════

const useResponsiveNbrArr = () => {
    const [nbrArr, setNbrArr] = useState(
        typeof window !== 'undefined' && window.innerWidth >= 768 ? 3 : 2
    );

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const mqMobile = window.matchMedia('(max-width: 768px)');
        const handleChange = () => {
            setNbrArr(mqMobile.matches ? 2 : 3);
        };

        handleChange();
        mqMobile.addEventListener('change', handleChange);
        return () => mqMobile.removeEventListener('change', handleChange);
    }, []);

    return nbrArr;
};

// ═══════════════════════════════════════════════════════════════════════════
// COMPOSANT PRINCIPAL
// ═══════════════════════════════════════════════════════════════════════════

const OrdersView = (props) => {
    const {
        infoSource,
        getOrderID,
        setShowOrderNote,
        setGraphicNoteBs,
        setGraphicImgBs,
        readOnly = false,
    } = props;
  __setElakayInfoSource(infoSource);

    const { token }     = isAuthenticated();
    const ot = useDropshippingText(infoSource, "dropshippingOrders");
    const nbrArr        = useResponsiveNbrArr();

    const orderID       = getOrderID?.oid;
    const orderIDI      = getOrderID?.pid;
    
    const [showOrderModal, setShowOrderModal] = useState(false);

    // ── State ────────────────────────────────────────────────────────────────
    const [orders,            setOrders]            = useState({});
    const [ordersShipping,    setOrdersShipping]    = useState({});
    const [ordersProducts,    setOrdersProducts]    = useState(null);
    const [orderPayment,      setOrderPayment]      = useState({});
    const [transactionId,     setTransactionId]     = useState(null);
    const [loading,           setLoading]           = useState(true);
    const [submitting,        setSubmitting]        = useState(false);
    const [feedback,          setFeedback]          = useState(null); // { type: 'success'|'error', message }

    const [getLakayPubCatProd, setLakayPubCatProd]= useState([])

    const [pageForm,          setPageForm]          = useState([true, false, false]);
    const [ticket,            setTicket]            = useState({
        status:    '',
        cause:     '',
        causeNote: '',
        asking:    '',
        // 🆕 Stable elakayTicket._id for the chosen reason -- lets the
        // backend's automatic ticket-suspension rules (Admin >
        // AnimationSettings) target this exact ticket type. `cause` itself
        // stays the human-readable label, unchanged, for every existing
        // reader of order.products[].ticket.cause.
        ticketTypeId: '',
        // 🆕 Parent umbrella of ticketTypeId (audit-only -- see the note on
        // ticketTypeId above; the backend has no independent copy of the
        // elakayTicket taxonomy to derive this from).
        parentTicketTypeId: '',
    });

    const { status, cause, causeNote, asking, ticketTypeId } = ticket;

    // ── Helpers calculs ─────────────────────────────────────────────────────
    const countProduct = useMemo(() => {
        return ordersProducts?.count || 0;
    }, [ordersProducts]);

    // Amounts of a PAID order come from the snapshot frozen when it was
    // charged (payment.financial), never from a new tax lookup with today's
    // table. Older orders without a snapshot keep their item formula; their
    // tax shows "Not recorded" instead of an invented 8.875 %.
    const financialSnapshot = ordersProducts?.payment?.financial;

    // Correction: un seul produit (view détail), calcul direct
    const itemsOrder = useMemo(() => {
        if (!ordersProducts) return 0;
        if (Number.isInteger(financialSnapshot?.itemsCents)) return financialSnapshot.itemsCents / 100;
        const historicalTotal = ordersProducts.dropshippingIn?.financial?.sellerTotal;
        if (historicalTotal != null) return Number(historicalTotal);
        const { count = 0, price = 0, salePrice = 0 } = ordersProducts;
        return count * (price * (100 - salePrice) / 100);
    }, [ordersProducts, financialSnapshot]);

    const shippingOrder = useMemo(() => {
        if (Number.isInteger(financialSnapshot?.shippingCents)) return financialSnapshot.shippingCents / 100;
        return (Number(ordersProducts?.shippingSnapshot?.chargedCents) || 0) / 100;
    }, [ordersProducts, financialSnapshot]);

    const taxOrderCents = useMemo(() => orderLineTaxCents(ordersProducts), [ordersProducts]);

    // What was actually authorized for this line when known, else the sum.
    const getTotal = useMemo(() => {
        const charged = ordersProducts?.payment?.amountCents;
        if (Number.isInteger(charged) && charged > 0) return charged / 100;
        return itemsOrder + shippingOrder + (taxOrderCents || 0) / 100;
    }, [ordersProducts, itemsOrder, shippingOrder, taxOrderCents]);

    // ── Show cancel/return buttons ──────────────────────────────────────────
    const currentOrderStatus = orders?.products?.status;
    const internalOrderItem = Boolean(orders?.products?.dropshippingIn?.providerId);

    const showCancelButton = useMemo(() =>
        internalOrderItem ? ["Not processed", "Processing"].includes(currentOrderStatus) : !["Cancelled", "Return or replace", "Delivered"].includes(currentOrderStatus),
        [currentOrderStatus, internalOrderItem]
    );

    const showReturnOrReplaceButton = useMemo(() =>
        internalOrderItem ? ["Shipped", "Delivered"].includes(currentOrderStatus) : !["Cancelled", "Return or replace", "Delivered"].includes(currentOrderStatus),
        [currentOrderStatus, internalOrderItem]
    );

    // ── Order loaded (tax comes from its stored snapshot, no new lookup) ──
    const newCartProd = useCallback(async (data) => {
        if (!Array.isArray(data) || data.length === 0) return;
        setOrders(data[0]);
        setOrdersShipping(data[0].shippingAddress || {});
        setOrdersProducts(data[0].products || null);
    }, []);

    // ── Load payment methods ────────────────────────────────────────────────
    const loadPaymentMethodView = useCallback((tkn, ID) => {
        if (!ID) return;
        getPaymentIntentView(tkn, ID).then(data => {
            if (data?.error) return;
            setOrderPayment({
                PM_id_sel:    null,
                b_name:       null,
                b_exp_month:  data?.cardInfo?.exp_month,
                b_exp_year:   data?.cardInfo?.exp_year,
                b_city:       null,
                b_brand:      data?.cardInfo?.brand,
                b_last4:      data?.cardInfo?.last4,
                b_country:    null,
                b_line1:      null,
                b_postal_code: null,
                b_state:      null,
            });
        });
    }, []);

    const loadRetrievePayment = useCallback((tkn, IDpaymentMethods) => {
        if (!IDpaymentMethods) return;
        retrievePayment(tkn, { IDpaymentMethods }).then(data => {
            if (data?.error) return;
            setOrderPayment({
                PM_id_sel:    data?.payment_method?.id,
                b_name:       data?.payment_method?.billing_details?.name,
                b_exp_month:  data?.payment_method?.card?.exp_month,
                b_exp_year:   data?.payment_method?.card?.exp_year,
                b_city:       data?.payment_method?.billing_details?.address?.city,
                b_brand:      data?.payment_method?.card?.brand,
                b_last4:      data?.payment_method?.card?.last4,
                b_country:    data?.payment_method?.billing_details?.address?.country,
                b_line1:      data?.payment_method?.billing_details?.address?.line1,
                b_postal_code: data?.payment_method?.billing_details?.address?.postal_code,
                b_state:      data?.payment_method?.billing_details?.address?.state,
            });
        });
    }, []);

    // After a payment action: the order as the server now stores it, and the
    // card its line really carries (never a card only picked in the browser).
    const refreshOrder = useCallback(async () => {
        const data = await OrdersBViewById(token, orderID, orderIDI);
        if (!Array.isArray(data) || data.error) return;
        await newCartProd(data);
        const pmId = data[0]?.products?.paymentIntent?.payment_method;
        if (pmId) loadRetrievePayment(token, pmId);
    }, [token, orderID, orderIDI, newCartProd, loadRetrievePayment]);

    // Back from the wallet's "Add Card" (returnUrl ...&changePayment=1).
    const [reopenPaymentChange, setReopenPaymentChange] = useState(() => new URLSearchParams(window.location.search).get("changePayment") === "1");
    const paymentChangeReopened = useCallback(() => {
        setReopenPaymentChange(false);
        const url = new URL(window.location.href);
        if (!url.searchParams.has("changePayment")) return;
        url.searchParams.delete("changePayment");
        window.history.replaceState({}, "", url.pathname + url.search);
    }, []);

         const loadProdUserLakay = async (userID) => {
                
               userID && await getLakayUser(userID, 0, 7, "createdAt", null, '', {filters : {filters: {}}, facet:["pubCategoryProd"]}).then(data => {
                
                    if(data.error || data.products?.length === 0){
                    }else{  
                        setLakayPubCatProd(data.pubCategoryProdMatrix)
                   
                    }
                }).catch(error => {
                });
            };
    // ── Load orders (avec isMounted guard) ──────────────────────────────────
    useEffect(() => {
        let isMounted = true;

        const loadOrders = async () => {
            if (!token || !orderID) return;
            setLoading(true);

            try {
                const data = await OrdersBViewById(token, orderID, orderIDI);
                if (!isMounted) return;
                if (data?.error) {
                    return;
                }
                loadProdUserLakay(data[0]?.prod_Owner);
                await newCartProd(data);
                if (!isMounted) return;

                const first = data[0];
                if (first) {
                    setGraphicNoteBs?.(first);
                    setTransactionId(first?.products?.transaction_id || null);

                    const pmId = first?.products?.paymentIntent?.payment_method;
                    if (pmId) {
                        loadRetrievePayment(token, pmId);
                    } else {
                        loadPaymentMethodView(token, first?.products?.transaction_id);
                    }

                    // Seules les commandes graphiques/custom ont un GraphicOrder associé --
                    // sauter l'appel pour les commandes normales évite un 404 systématique.
                    if (first?.products?.graphic) {
                        loadGraphic();
                    }
                }
            } catch (err) {
                console.error('[OrdersView] loadOrders error:', err);
            } finally {
                if (isMounted) setLoading(false);
            }
        };
        const loadGraphic = async () => {
            if (!token || !orderID) return;
            try {
                const data = await getGraphicOrder(token, orderID);
                if (!isMounted) return;
                if (data?.error) return;
                setGraphicImgBs?.(data);
            } catch (err) {
                console.error('[OrdersView] loadGraphic error:', err);
            }
        };

        loadOrders();

        return () => { isMounted = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, orderID, orderIDI]);

    // ── Submit ticket ───────────────────────────────────────────────────────
    const clickBtnTicket = useCallback(async () => {
        if (!cause) {
            setFeedback({ type: 'error', message: __elakayText("t006", "Please select a reason.") });
            return;
        }

        setSubmitting(true);
        setFeedback(null);

        try {
            const data = await updateOrder(
                token,
                getOrderID,
                { orders: { ticket, status }, transaction_id: transactionId }
            );
            if (data?.error) {
                setFeedback({ type: 'error', message: data.error });
                return;
            }
            setFeedback({ type: 'success', message: __elakayText("t007", "Your request has been submitted.") });
            // Reset form after delay
            setTimeout(() => {
                setTicket({ status: '', cause: '', causeNote: '', asking: '', ticketTypeId: '', parentTicketTypeId: '' });
                setPageForm([true, false, false]);
                setFeedback(null);
            }, 2500);
        } catch (err) {
            setFeedback({ type: 'error', message: __elakayText("t008", "An error occurred. Please try again.") });
        } finally {
            setSubmitting(false);
        }
    }, [token, getOrderID, ticket, status, cause, transactionId]);

    // ── Handlers form ───────────────────────────────────────────────────────
    const handlePageForm = useCallback((page) => {
        // Each form has its own reason group: reset the chosen reason/action
        // so a Cancel reason can never be submitted with a Return request.
        const resetReason = { cause: '', asking: '', ticketTypeId: '', parentTicketTypeId: '' };
        if (page === 'return') {
            setTicket(prev => ({ ...prev, ...resetReason, status: "Return or replace" }));
            setPageForm([false, true, false]);
        } else if (page === 'cancel') {
            setTicket(prev => ({ ...prev, ...resetReason, status: "Cancelled" }));
            setPageForm([false, false, true]);
        } else {
            setTicket(prev => ({ ...prev, ...resetReason, status: '' }));
            setPageForm([true, false, false]);
        }
        setFeedback(null);
    }, []);

    const handleChange = useCallback((name) => (event) => {
        setTicket(prev => ({ ...prev, [name]: event.target.value }));
    }, []);

    // ═══════════════════════════════════════════════════════════════════════
    // RENDER HELPERS
    // ═══════════════════════════════════════════════════════════════════════

    // URL image produit
    const productId = orders?.products?.productID;
    const urlImage  = productId ? `/product/preview/${productId}` : '#';

    // ── Product Card ────────────────────────────────────────────────────────
    const productView = () => (
        <div className="ov-product-card">
            <div className="ov-product-header">
                <h3>
                    {infoSource?.TruncatedText
                        ? <infoSource.TruncatedText text={orders?.prod_name || ''} limits={[40, 30]} showToggle={true} />
                        : orders?.prod_name
                    }
                </h3>
            </div>
            <div className="ov-product-body">
                <div className="ov-product-image">
                    {orders?.products && (
                        <Link to={urlImage}>
                            <ShowimagesLoading src={orders.products.urlImg} width={120} />
                        </Link>
                    )}
                </div>
                <div className="ov-product-info">
                    <h6>
                        {infoSource?.TruncatedText
                            ? <infoSource.TruncatedText text={orders?.prod_Description || ''} limits={[70, 50]} showToggle={true} />
                            : orders?.prod_Description
                        }
                    </h6>
                    {orders?.prod_filterProduct?.filter && (
                        <Filters filter={filterProductSel(orders)} nexLine={true} />
                    )}
                </div>
             
            </div>    
         {!readOnly && ordersProducts.graphic && (
                <button className="ov-btn ov-btn-outline" onClick={() => setShowOrderModal(true)}>
                    {__elakayText("t009", "View Order Details")}
                </button>
            )}
        </div>
    );

    // ── Payment table ───────────────────────────────────────────────────────

    const paymentTable = () => (
        <table className="ov-table">
            <tbody>
                <tr>
                    <th>{countProduct} {elakayPluralRule(countProduct) === "one"
                        ? infoSource?.laguangeElakay?.('label', infoSource.languageAPI)?.item || elakayAutoText("h_order_item_one", "item")
                        : infoSource?.laguangeElakay?.('label', infoSource.languageAPI)?.items || elakayAutoText("h_7316c8b2e74870", "items")}</th>
                    <td>{formatCurrency(itemsOrder)}</td>
                </tr>
                <tr>
                    <th>{infoSource?.laguangeElakay?.('label', infoSource.languageAPI)?.shipping || elakayAutoText("h_694e6062a66864", "Shipping")}</th>
                    <td>{formatCurrency(shippingOrder)}</td>
                </tr>
                <tr>
                    <th>{infoSource?.laguangeElakay?.('label', infoSource.languageAPI)?.tax || elakayAutoText("h_9be70f66f8dd4d", "Tax")}</th>
                    <td data-testid="order-view-tax">{orderLineTaxText(ordersProducts)}</td>
                </tr>
                <tr className="ov-total-row">
                    <th>{infoSource?.laguangeElakay?.('label', infoSource.languageAPI)?.total || elakayAutoText("h_b25928c6990255", "Total")}</th>
                    <td>{formatCurrency(getTotal)}</td>
                </tr>
            </tbody>
        </table>
    );

    // ── Info section (payment + shipping) ───────────────────────────────────
    const infoPaymentSection = () => (
        <div className="ov-info-section">
            <div className="ov-timestamp">
                <span>🕐</span>
                <span>{orders?.createdAt ? elakayFromNow(orders.createdAt) : ''}</span>
            </div>

            <div className="ov-info-grid">
                {/* Payment info */}
                <div>
                    <h5 className="ov-section-title">
                        {infoSource?.laguangeElakay?.('title', infoSource.languageAPI)?.paymentInfo || elakayAutoText("h_ed1703f34e98c5", "Payment Info")}
                    </h5>
                    {paymentTable()}

                    <OrderPaymentMethod
                        orderId={orderID}
                        productId={orderIDI}
                        line={orders?.products}
                        card={objNotEmpty(orderPayment) ? orderPayment : null}
                        title={infoSource?.laguangeElakay?.('title', infoSource.languageAPI)?.paymentMethods || elakayAutoText("h_f383f6a23c878e", "Payment Method")}
                        readOnly={readOnly}
                        autoOpenChange={reopenPaymentChange}
                        onAutoOpenHandled={paymentChangeReopened}
                        onChanged={refreshOrder}
                    />
                </div>

                {/* Shipping info */}
                <div>
                    <h5 className="ov-section-title">
                        {infoSource?.laguangeElakay?.('title', infoSource.languageAPI)?.shippnigAddress || elakayAutoText("h_dbd7c38dd022f2", "Shipping Address")}
                    </h5>
                    <div className="ov-card-info">
                        <h6>📦 {ordersShipping.firstName} {ordersShipping.lastName}</h6>
                        <h6>📍 {ordersShipping.line1}</h6>
                        <h6>{ordersShipping.city}, {ordersShipping.state}, {ordersShipping.postal_code}</h6>
                        <h6>🌍 {ordersShipping.country}</h6>
                    </div>
                    {internalOrderItem && <div className="ov-card-info">
                        <p>{statusLabel(currentOrderStatus, ot)}</p>
                        <p>{ot("trackingNumber")}: {orders.products.trackingNumber || orders.products.delivery?.trackingNumber || orders.products.info?.tracking || "—"}</p>
                        {safeTrackingUrl(orders.products.trackingUrl || orders.products.delivery?.trackingUrl || orders.products.info?.urlTracking) && <a href={safeTrackingUrl(orders.products.trackingUrl || orders.products.delivery?.trackingUrl || orders.products.info?.urlTracking)} target="_blank" rel="noreferrer">{ot("trackingNumber")}</a>}
                    </div>}

                    <OrderFinancialActions
                        order={orders}
                        line={orders.products}
                        buyer
                        onChanged={refreshOrder}
                    />
                    {!readOnly && <div className="ov-btn-group">
                        {showCancelButton && (
                            <button
                                onClick={() => handlePageForm('cancel')}
                                className="ov-btn ov-btn-outline"
                            >
                                🚫 {infoSource?.laguangeElakay?.('Button', infoSource.languageAPI)?.cancelOrder || elakayAutoText("h_87125442f43bbc", "Cancel Order")}
                            </button>
                        )}
                        {showReturnOrReplaceButton && (
                            <button
                                onClick={() => handlePageForm('return')}
                                className="ov-btn ov-btn-outline"
                            >
                                🔄 {infoSource?.laguangeElakay?.('Button', infoSource.languageAPI)?.returnReplace || elakayAutoText("h_4665c569994cd9", "Return / Replace")}
                            </button>
                        )}
                    </div>}
                </div>
            </div>
        </div>
    );

    // ── Form return/cancel ──────────────────────────────────────────────────
    const formRCR = () => {
        const text      = infoSource?.language?.(infoSource, "text", "textOrderReturnDet")     || '';
        const textLess  = infoSource?.language?.(infoSource, "text", "textOrderReturnDetLess") || '';
        const text1     = infoSource?.language?.(infoSource, "text", "textOrderReturnAct")     || '';
        const textLess1 = infoSource?.language?.(infoSource, "text", "textOrderReturnActLess") || '';
        const text2     = infoSource?.language?.(infoSource, "text", "textOrderRefunds")       || '';
        const textLess2 = infoSource?.language?.(infoSource, "text", "textOrderRefundsLess")   || '';

        // Reasons are read from the app-wide language catalogue (MongoDB,
        // falling back to the bundled JSON) for the action being filed; the
        // points they carry are resolved server-side from Auto Suspend Ticket
        // when the ticket is submitted, never here.
        const catalogueLoaded = Boolean(infoSource?.languageAPI?.elakayInfo) && !infoSource.languageAPI.loading;
        const elakayTicket  = catalogueLoaded ? infoSource.laguangeElakay('elakayTicket', infoSource.languageAPI) : null;
        const reasonParent  = reasonGroupForStatus(elakayTicket, status);
        const reasons       = reasonsForStatus(elakayTicket, status);
        const actionReturn  = ticketGroup(elakayTicket, 'returnAction');
        const reasonState   = !catalogueLoaded ? 'loading' : !reasonParent ? 'error' : reasons.length === 0 ? 'empty' : 'ready';
        const reasonPlaceholder = {
            loading: __elakayText("t012", "Loading reasons..."),
            empty:   __elakayText("t013", "No reason available for this action."),
            error:   __elakayText("t014", "Reasons could not be loaded. Please try again later."),
        }[reasonState] || __elakayText("t002", "Select a reason");

        const isReturnForm = pageForm[1];
        return (
            <div className="ov-form">
                <h2>📋 {orderStatusLabel(status)}</h2>

                {feedback && (
                    <div className={`ov-feedback ov-feedback-${feedback.type}`}>
                        {feedback.type === 'success' ? '✓' : '⚠'} {feedback.message}
                    </div>
                )}

                <div className="ov-form-group">
                    <label>{infoSource?.language?.(infoSource, "label", "reason") || elakayAutoText("h_f219cc0614ae68", "Reason")}</label>
                    {text && <ReadMoreLess infoSource={infoSource} text={text} textLess={textLess} showNB={false} />}
                    <select
                        onChange={(event) => {
                            const id = event.target.value;
                            const match = reasons.find((option) => String(option._id) === id);
                            setTicket(prev => ({ ...prev, cause: match?.ticket || '', ticketTypeId: match ? id : '', parentTicketTypeId: match ? String(reasonParent._id) : '' }));
                        }}
                        className="ov-form-control"
                        value={ticketTypeId}
                        disabled={reasonState !== 'ready'}
                        aria-busy={reasonState === 'loading'}
                        aria-label={infoSource?.language?.(infoSource, "label", "reason") || elakayAutoText("h_f219cc0614ae68", "Reason")}
                    >
                        <option value="">{reasonPlaceholder}</option>
                        {reasons.map((ob) => (
                            <option key={ob._id} value={String(ob._id)}>{ob.ticket}</option>
                        ))}
                    </select>
                    {(reasonState === 'empty' || reasonState === 'error') && (
                        <div className={`ov-feedback ov-feedback-error`} role="status">⚠ {reasonPlaceholder}</div>
                    )}
                </div>

                <div className="ov-form-group">
                    <label>{infoSource?.language?.(infoSource, "label", "details") || elakayAutoText("h_dc3decbb938475", "Details")}</label>
                    <textarea
                        onChange={handleChange('causeNote')}
                        className="ov-form-control"
                        placeholder={__elakayText("t003", "Please provide additional details...")}
                        value={causeNote}
                    />
                </div>

                {isReturnForm && (
                    <div className="ov-form-group">
                        <label>{infoSource?.language?.(infoSource, "label", "action") || elakayAutoText("h_97c89a4d6630ad", "Action")}</label>
                        {text1 && <ReadMoreLess infoSource={infoSource} text={text1} textLess={textLess1} showNB={false} />}
                        <select
                            onChange={handleChange('asking')}
                            className="ov-form-control"
                            value={asking}
                        >
                            <option value="">{__elakayText("t004", "Select an action")}</option>
                            {childrenOf(elakayTicket, actionReturn).map((ob) => (
                                <option key={ob._id} value={ob.ticket}>{ob.ticket}</option>
                            ))}
                        </select>
                    </div>
                )}

                <div className="ov-btn-group">
                    <button
                        onClick={() => handlePageForm()}
                        className="ov-btn ov-btn-outline"
                        disabled={submitting}
                    >
                        ← {infoSource?.language?.(infoSource, "Button", "cancel") || elakayAutoText("h_77dfd2135f4db7", "Cancel")}
                    </button>
                    <button
                        onClick={clickBtnTicket}
                        className="ov-btn ov-btn-primary"
                        disabled={submitting || !cause}
                    >
                        {submitting
                            ? elakayAutoText("h_0cebd16b648ed4", "⏳ Submitting...")
                            : <>✓ {infoSource?.language?.(infoSource, "Button", "submit") || elakayAutoText("h_2dacf659598498", "Submit")}</>
                        }
                    </button>
                </div>

                {text2 && (
                    <ReadMoreLess
                        infoSource={infoSource}
                        text={text2}
                        textLess={textLess2}
                    />
                )}
            </div>
        );
    };

    // ═══════════════════════════════════════════════════════════════════════
    // RENDER
    // ═══════════════════════════════════════════════════════════════════════

    if (loading) {
        return (
            <div className="ov-container">
                <div className="ov-loading">{__elakayText("t005", "Loading order details...")}</div>
            </div>
        );
    }

    return (
        <div className="ov-container">
         {!showOrderModal &&  <>
            {productView()}
            {pageForm[0] && infoPaymentSection()}
            {!pageForm[0] && formRCR()}
            </>}
            {showOrderModal && <GraffitiOrderClient 
            order={orders} 
            infoSource={infoSource}
            onClose={() => setShowOrderModal(false)}
            onAction={(data) => {
              /* Recharger l'order si besoin */
              if (data.type === "ask_appended" || 
                  data.type === "approved" || 
                  data.type === "rejected") {
                // reloadOrder();
              }
            }}
          />}
{/* link shope du user admin qui t'ajouter dans le systeme */}
{ getLakayPubCatProd?.products?.length > 0 && <SwiperPubCategoryProdMatrix
        Follow ={true}
        infoSource ={infoSource}
         pubCategoryProdMatrix= {getLakayPubCatProd}
        />}
        
        </div>
    );
};

export default OrdersView;
